/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ActionMountSheet } from "./ActionMountSheet";
import { ActionMountWorkbook } from "./ActionMountWorkbook";
import { ActionMountField } from "./ActionMountField";
import { ActionMountDocument } from "./ActionMountDocument";
import { ActionMountFile } from "./ActionMountFile";
export const ActionMount = core.serialization
    .union("type", {
    sheet: ActionMountSheet,
    workbook: ActionMountWorkbook,
    field: ActionMountField,
    document: ActionMountDocument,
    file: ActionMountFile,
})
    .transform({
    transform: (value) => value,
    untransform: (value) => value,
});
